import React from "react";
import { Link as RouterLink } from 'react-router-dom';
import { Link, useTheme } from "@mui/material";

const DefaultLink = ({
    label,
    to,
    fontSize = undefined,
    fontWeight = undefined,
    color = null,
    colorOnHover = null,
    allCaps = false,
}) => {
    const theme = useTheme();
    return (
        <Link
            component={RouterLink}
            to={to}
            fontSize={fontSize}
            fontWeight={fontWeight}
            underline="hover"
            color={color ?? theme.palette.resolutionBlue.dark}
            sx={{
                fontVariant: allCaps ? "all-small-caps" : undefined,
                "&:hover": {
                    color: colorOnHover ?? theme.palette.resolutionBlue.light,
                },
            }}
        >
            {label}
        </Link>
    );
}

export default DefaultLink;
